export default __webpack_public_path__ + "static/media/techofest.f2dd07e8.jpg";